import React from 'react'

const VideoAds = () => {
  return (
    <>
    
    <div className="video-ads-section">
        <div className="page-wrapper">
          <div className='video-ad-rap'>
            <div className="video-ads">
                <h1>Video Ads</h1>
            </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default VideoAds
